module.exports = __webpack_public_path__ + "static/media/Thought-leaders-twitter.efb1fe66.jpg";